export default __webpack_public_path__ + "static/media/Filled.81073a32.png";